import { BaseResponse, TableList } from '@/types/common';
import axiosInstance from './axiosInstance';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

export type TopicMngListOrderByField =
  | 'createTime'
  | 'recommendScore'
  | 'artworkNum'
  | 'collectionNum';

export interface TopicMngListParams {
  tagId?: string;
  tagName?: string;
  createDateStart?: string;
  createDateEnd?: string;
  creatorName?: string;
  pageSize: number;
  currentPage: number;
  orderByField?: TopicMngListOrderByField;
  isDesc?: boolean;
}

export interface TopicMngItem {
  tagId: string;
  tagName: string;
  description: string;
  artworkNum: number;
  collectionNum: number;
  recommendScore: number;
  createTime: string;
  updateTime: string;
  creatorName: string;
}

export const getToppicMngList = async (params: TopicMngListParams) => {
  const res = await axiosInstance.post<BaseResponse<TableList<TopicMngItem>>>(
    `${baseUrl}/api/tags/v1/pageList`,
    params
  );
  return res.data;
};

export interface TopicMngDetail extends TopicMngItem {
  artworkIds: string;
  topIds: string;
}

export const getTopicMngDetail = async (tagId: string) => {
  const res = await axiosInstance.get<BaseResponse<TopicMngDetail>>(
    `${baseUrl}/api/tags/v1/detail`,
    { params: { tagId } }
  );
  return res.data;
};

export enum TopicMngPreCheckResult {
  SUCCESS = 0, // 成功
  REPEAT = 1, // 失败，有重复话题
  MERGE = 2, // 失败，合并话题
}

export interface TopicMngPreCheckResp {
  result: TopicMngPreCheckResult;
  message: string;
}

export const topicPreCheck = async (tagName: string) => {
  const res = await axiosInstance.get<BaseResponse<TopicMngPreCheckResp>>(
    `${baseUrl}/api/tags/v1/check`,
    {
      params: { tagName },
    }
  );
  return res.data;
};

export interface TopicMngCreateParams {
  tagName: string;
  description: string;
  artworkIds: string;
  recommendScore: number;
}

export const topicCreate = async (params: TopicMngCreateParams) => {
  const res = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/api/tags/v1/create`,
    params
  );
  return res.data;
};

export interface TopicMngUpdateParams extends TopicMngCreateParams {
  tagId: string;
  topIds: string;
}

export const topicUpdate = async (params: TopicMngUpdateParams) => {
  const res = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/api/tags/v1/update`,
    params
  );
  return res.data;
};
